import { FIELDS } from '@/pages/Invoices/components/InvoiceLines/constants';

const rmaPartFields = [
  {
    title: 'Qty',
    field: FIELDS.QUANTITY,
  },
  {
    title: 'Part Number',
    field: FIELDS.PART_NUMBER,
  },
  {
    title: 'Customer PN',
    field: FIELDS.CUSTOMER_PN,
    
  },
  {
    title: 'Alt Number',
    field: FIELDS.ALT_NUMBER,
    
  },
  {
    title: 'Description',
    field: FIELDS.DESCRIPTION,
    
  },
  {
    title: 'Mfr',
    field: FIELDS.MFR,
    
  },
  {
    title: 'Date Code',
    field: FIELDS.DATE_CODE,
    
  },
  {
    title: 'Condition',
    field: FIELDS.CONDITION,
    
  },
  {
    title: 'Price',
    field: FIELDS.PRICE,
    
  },
  {
    title: 'Line Total',
    field: FIELDS.TOTAL,
    
  },
  {
    title: 'CI',
    field: FIELDS.CLASS,
    
  },

];

export default rmaPartFields;
